module.exports = __webpack_public_path__ + "media/images/map/car1-b7f77f06bb5698c8f2630fe1540a65be.png";